import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Button,
  Tag,
  Form,
  Input,
  message,
  Modal,
  Space,
  Table,
  InputNumber,
  Card,
  Switch,
  Row,
  Col,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import { AiFillDelete } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import UploadFile from "../../components/UploadFile";
import newspaperApi from "../../api/newPaperApi";
import { fileManagerActions } from "../../store";
import { LocalImage } from "../../components/ImageUtil";
import { urlRegex } from "../../utils";

const dataExample = {
  id: null,
  name: null,
  link: null,
  index: 0,
  image: null,
  display: false,
};
const Newspapers = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormData, setValueFormData] = useState(dataExample);
  const [inputFilter, setFilter] = useState({
    name: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [lstNewPaper, setLstNewPaper] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getNewPapers();
    form.setFieldsValue(valueFormData);
  }, [inputFilter, form, valueFormData]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, name: e.target.value });
  };

  const getPapersDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getNewPapers = () => {
    newspaperApi.getNewPapers(inputFilter).then((res) => {
      if (res?.results) {
        setLstNewPaper(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },

    {
      title: "Ảnh hiển thị",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 350,
      className: "text-center",
    },
    {
      title: "Tên trang tin",
      dataIndex: "name",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Liên kết",
      dataIndex: "link",
      render: (text) => (
        <a target={"_blank"} href={urlRegex(text)}>
          {text}
        </a>
      ),
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "index",
      className: "text-center",
      width: "5%",
    },
    {
      title: "Trạng thái",
      dataIndex: "display",
      render: (display) => (
        <>
          {display === true && (
            <Tag color="green" key={display}>
              Hoạt động
            </Tag>
          )}
          {display === false && (
            <Tag color="red" key={display}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deletePaper(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ].filter((item) => !item.hidden);

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const confirm = Modal.confirm;

  const deletePaper = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa liên kết này không?",
      onOk() {
        newspaperApi
          .deleteNewPaper(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getNewPapers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deletePapers = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa liên kết này không?",
      onOk() {
        newspaperApi
          .deleteNewPaper(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getNewPapers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const showEditModal = (record) => {
    setEditModal(true);
    setTitleModal("Sửa liên kết");
    setImageNull(record.image || null);
    setValueFormData({
      id: record.id,
      name: record.name,
      link: record.link,
      index: record.index,
      display: record.display,
    });
    setIsModalEditVisible(true);
  };

  const showCreateModal = () => {
    form.resetFields();
    setTitleModal("Thêm liên kết");
    setValueFormData(dataExample);
    setImageNull(null);
    setEditModal(false);
    setIsModalEditVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updatePaper(values);
      } else {
        if (fileImageUrl !== null) {
          createPaper(values);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Vui lòng tải ảnh lên!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    },
    [isEditModal, fileImageUrl]
  );

  const createPaper = (data) => {
    const payload = {
      name: data.name,
      link: data.link,
      index: data.index,
      image: fileImageUrl,
      display: data.display,
    };
    console.log(payload);
    newspaperApi.createNewPaper(payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getNewPapers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updatePaper = (data) => {
    const payload = {
      name: data.name,
      link: data.link,
      index: data.index,
      image: fileImageUrl,
      display: data.display,
    };
    console.log(payload);
    newspaperApi.updateNewPaper(data.id, payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getNewPapers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const closePopup = () => {
    setIsModalEditVisible(false);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={24}>
            <Col span={24}>
              <label> Tìm kiếm</label>
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên trang tin..."
                defaultValue={inputFilter.name}
                onChange={getPapersDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
          </Row>
        </Card>
        <br />
        <Space size={10}>
          <Button type="dashed" onClick={() => showCreateModal()} size="small">
            <EditOutlined /> &nbsp; Thêm liên kết
          </Button>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deletePapers();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstNewPaper}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormData}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="Id" name="id">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên trang tin"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên trang tin!",
                  },
                ]}
              >
                <Input placeholder="Nhập tên..." />
              </Form.Item>

              <Form.Item
                label="Liên kết"
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập liên kết!",
                  },
                ]}
              >
                <Input placeholder="Nhập liên kết..." />
              </Form.Item>
              <Form.Item
                label="Thứ tự hiển thị"
                name="index"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập thứ tự hiển thị!",
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="display"
              >
                <Switch />
              </Form.Item>

              <Form.Item label="Ảnh hiển thị">
                <UploadFile />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Newspapers;
